import React from "react";
import { useTranslation } from "@/src/i18n/client";
import { FmButton, FmDialog } from "@/ui-component";
import stl from "./style.module.scss";
import classnames from "classnames";
import ShareComponent from "@/src/components/ShareComponent";
interface IProps {
    show: boolean;
    onClose: (show: boolean) => void;
}
const ShareComponentDialog: React.FC<IProps> = (props) => {
    const { t } = useTranslation("productDetail");

    const { onClose, show } = props;

    return (
        <FmDialog
            open={show}
            // transparent
            dialogTitle={
                <span className={classnames(stl["product-detail-share-title"])}>
                    {t("productDetail:SHARE_TITLE")}
                </span>
            }
            // maskClosable={true}
            showBottomButton
            onClose={onClose}
            renderBottom={
                <FmButton
                    variant="text"
                    fullWidth
                    onClick={() => onClose(!show)}
                    size={"large"}
                >
                    {t("productDetail:CANCEL")}
                </FmButton>
            }
            className={stl["share-compoent-dialog-container"]}
            bottomClassName={stl["share-bottom"]}
            contentClassName={classnames(stl["share-container"])}
            titleClassName={stl["share-component-dialog-title"]}
        >
            <ShareComponent openShareWindow isProductDetail />
        </FmDialog>
    );
};

export default ShareComponentDialog;
